import DragAndDropContainer from "../../../../ui library/components/file-upload/DragAndDropContainer";

import ContractsModalField from "./ContractsModalField";

export default function ContractsFileField({ fieldValue, onChange }) {
  return (
    <ContractsModalField
      label="Contract File"
      renderValue={
        <DragAndDropContainer
          initValue={fieldValue}
          onValueChange={(_, value) => onChange("contractFile", value)}
        />
      }
    />
  );
}
